import { FILTER_VALUES } from "./filters";
import { USAGE_VIEW_TYPES } from "./usage";
export const queryKeys = {
    dashboard: {
        data: (chartDays, customerId)=>[
                "dashboard",
                chartDays,
                customerId
            ]
    },
    apiKeys: {
        all: ()=>[
                "apiKeys"
            ],
        list: (productCode = FILTER_VALUES.ALL, customerId)=>[
                "apiKeys",
                productCode,
                customerId
            ]
    },
    products: {
        all: ()=>[
                "products"
            ],
        available: (customerId)=>[
                "available-products",
                customerId
            ],
        byCode: (productCode)=>[
                "product",
                productCode
            ]
    },
    customers: {
        all: ()=>[
                "customers"
            ]
    },
    organizations: {
        all: ()=>[
                "all-organizations"
            ],
        users: (customerId)=>[
                "organizationUsers",
                customerId
            ],
        settings: ()=>[
                "organizationSettings"
            ]
    },
    contracts: {
        list: (productCode, customerId)=>[
                "contracts",
                productCode,
                customerId
            ],
        pricingPolicies: ()=>[
                "pricing-policies"
            ]
    },
    licenses: {
        byContract: (contractId, status)=>[
                "licenses",
                contractId,
                status
            ]
    },
    invoices: {
        list: (filters, customerId)=>[
                "invoices",
                filters,
                customerId
            ],
        byId: (invoiceId, customerId)=>[
                "invoice",
                invoiceId,
                customerId
            ]
    },
    auditLogs: {
        list: (startDate, endDate, apiKeyId, customerId, limit, nextToken)=>[
                "auditLogs",
                startDate,
                endDate,
                apiKeyId,
                customerId,
                limit,
                nextToken
            ]
    },
    changelogs: {
        list: (limit, nextToken, distribution = "blast-c")=>[
                "changelogs",
                limit,
                nextToken,
                distribution
            ],
        byId: (changelogId, distribution)=>[
                "changelog",
                changelogId,
                distribution
            ]
    },
    mfa: {
        status: ()=>[
                "mfa-status"
            ]
    },
    usage: {
        all: ()=>[
                "usage"
            ],
        chartHourly: (contractId, selectedDate, selectedApiKey, customerId, productCode)=>[
                "usage",
                USAGE_VIEW_TYPES.HOURLY,
                contractId,
                selectedDate,
                selectedApiKey,
                customerId,
                productCode
            ],
        chartDaily: (contractId, startDate, endDate, selectedApiKey, customerId, productCode)=>[
                "usage",
                USAGE_VIEW_TYPES.DAILY,
                contractId,
                startDate,
                endDate,
                selectedApiKey,
                customerId,
                productCode
            ],
        chartMetered: (contractId, startDate, endDate, selectedApiKey, customerId)=>[
                "usage",
                "metered",
                contractId,
                startDate,
                endDate,
                selectedApiKey,
                customerId
            ],
        metered: (contractId, startDate, endDate, apiKeyId, customerId)=>[
                "meteredUsage",
                contractId,
                startDate,
                endDate,
                apiKeyId,
                customerId
            ],
        daily: (contractId, startDate, endDate, apiKeyId, customerId)=>[
                "dailyUsage",
                contractId,
                startDate,
                endDate,
                apiKeyId,
                customerId
            ],
        hourly: (contractId, dayUtc, apiKeyId, customerId)=>[
                "hourlyUsage",
                contractId,
                dayUtc,
                apiKeyId,
                customerId
            ]
    }
};
